import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, MessageCircle, Heart } from 'lucide-react';
import { SCShell, SCHeading, ghostBtn, goldBtn, RequireAuth } from './sc/SCShared';
import { scMatches, scFileUrl } from '../api';

const Inner = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { scMatches().then((d) => setMatches(d.matches || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <SCShell>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <SCHeading eyebrow="Matches" title="Your connections" sub="When you and someone both like each other, they appear here." />
        <Link to="/sacred-connections/discover" className={ghostBtn}>Discover more</Link>
      </div>
      {loading ? <p className="font-cormorant text-2xl text-[#e9d8ff]/60 animate-pulse">Loading…</p>
        : matches.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="h-10 w-10 text-[#8b5cf6] mx-auto mb-4" />
            <p className="font-cormorant text-2xl text-[#e9d8ff]/70">No connections yet.</p>
            <p className="font-jost text-sm text-[#e9d8ff]/50 mt-2">Keep exploring — a mutual like opens a connection.</p>
            <Link to="/sacred-connections/discover" className={`${goldBtn} mt-6`}>Start discovering</Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sc-matches-grid">
            {matches.map((m) => {
              const p = m.profile;
              return (
                <div key={m.match_id} className="rounded-2xl overflow-hidden border border-[#8b5cf6]/25 bg-white/[0.03] backdrop-blur-md" data-testid={`sc-match-${p.user_id}`}>
                  <div className="h-48 bg-black/40">
                    {p.profile_photo ? <img src={scFileUrl(p.profile_photo)} alt={p.display_name} className="w-full h-full object-cover" />
                      : <div className="w-full h-full flex items-center justify-center"><span className="font-cinzel text-5xl text-[#8b5cf6]/50">{(p.display_name || '?')[0]}</span></div>}
                  </div>
                  <div className="p-5">
                    <h3 className="font-cinzel text-lg text-[#f5d786]">{p.display_name}{p.age ? `, ${p.age}` : ''}</h3>
                    {p.location_area && <p className="font-jost text-xs text-[#e9d8ff]/60 flex items-center gap-1 mt-1"><MapPin className="h-3 w-3" /> {p.location_area}</p>}
                    <Link to={`/sacred-connections/messages?match=${m.match_id}`} data-testid={`sc-match-msg-${p.user_id}`} className="mt-4 w-full rounded-full py-2.5 bg-gradient-to-r from-[#7c3aed] to-[#d946ef] text-white flex items-center justify-center gap-2 text-sm"><MessageCircle className="h-4 w-4" /> Message</Link>
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </SCShell>
  );
};

const SCMatches = () => <RequireAuth><Inner /></RequireAuth>;
export default SCMatches;
